import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { SettingsModalContentContainer } from './SettingsModalContent/SettingsModalContentContainer';
import { closeShareModal } from '../../actions/shareCollection';
import { ShareSettingsModal, ShareModalHeader } from '../../components/ShareSettingsModal';
import { selectOpenedShareCollection, selectShareCollection } from '../../selectors';

export const SettingsModalContainer: React.FunctionComponent<{}> = () => {
  const { openedId } = useSelector(selectShareCollection, shallowEqual);
  const openedCollection = useSelector(selectOpenedShareCollection, shallowEqual);
  const dispatch = useDispatch();

  const handleCloseModal = React.useCallback(() => {
    dispatch(closeShareModal());
  }, [dispatch]);

  if (!openedId || !openedCollection) {
    return null;
  }

  return (
    <ShareSettingsModal
      open={!!openedId}
      onClose={handleCloseModal}
      header={<ShareModalHeader />}
      content={<SettingsModalContentContainer />}
    />
  );
};
